/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PaymentPeriod {
    Yearly = 'Yearly',
    Quarterly = 'Quarterly',
    Halfyearly = 'Halfyearly',
    Monthly = 'Monthly'
  }

    export const PaymentPeriodTranslocoMap: Record<PaymentPeriod, string> = {
    [PaymentPeriod.Yearly]: 'paymentPeriod.yearly',
    [PaymentPeriod.Quarterly]: 'paymentPeriod.quarterly',
    [PaymentPeriod.Halfyearly]: 'paymentPeriod.halfyearly',
    [PaymentPeriod.Monthly]: 'paymentPeriod.monthly',
    };

    export const PaymentPeriodOptions = [
  { value: PaymentPeriod.Yearly, labelKey: 'paymentPeriod.yearly' },
  { value: PaymentPeriod.Quarterly, labelKey: 'paymentPeriod.quarterly' },
  { value: PaymentPeriod.Halfyearly, labelKey: 'paymentPeriod.halfyearly' },
  { value: PaymentPeriod.Monthly, labelKey: 'paymentPeriod.monthly' },
    ];

